module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-option",
    class: {
      'disabled': _vm.disabled, 'selected': _vm.selected, 'no-wrap': _vm.noWrap, 'centralised': _vm.centralise
    },
    on: {
      "click": _vm.click
    }
  }, [_c('div', {
    staticClass: "inner flex-v-center"
  }, [_c('span', {
    staticClass: "title",
    attrs: {
      "title": _vm.mainText
    }
  }, [_vm._v("\n          " + _vm._s(_vm.mainText) + "\n      ")]), _vm._v(" "), _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "30px",
      "height": "30px"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('rect', {
    attrs: {
      "x": "5",
      "y": "5",
      "width": "20",
      "height": "20",
      "rx": "3"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "28 3 15.1266569 17 10 11.8756235"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-183cdc50","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/listOption.vue
// module id = 585
// module chunks = 0